var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 981 981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#97675e;}.cls-2{fill:#173856;}.cls-3{fill:#20456e;}.cls-4{fill:#639;}.cls-5{fill:#2d120a;}.cls-6{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "frame 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_30",
    "data-name": "Calque 30"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 489.41,
    cy: 219.5,
    r: 169
  }), /*#__PURE__*/React.createElement("g", {
    id: "frame_2_miroir",
    "data-name": "frame 2 miroir"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1099.41,1233.5s34,67,64,35-23-74-23-74Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M975.41,1089.5s-23-82,55-70l125,172s-23,41-60,50C1047.41,1183.5,975.41,1089.5,975.41,1089.5Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M940.41,1251.5v-203s0-50,66-50,66,40,66,40v213Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M940.41,1251.5s-2,103-58,184c-14,0-41,71-41,71l156,69s35-55-19-85c30-46,94-175,94-239Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1172.41,1457.5s-42.5-166.38-100.5-206.5h-132c-10.94,38.17,82.16,144.56,82.16,144.56s47.34,67.94,52.34,109.94c0,0-5,9-2,18s25,52,25,52l157-75S1228.41,1421.5,1172.41,1457.5Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bras_arri\\xE8re",
    "data-name": "bras arri\\xE8re"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M851,1194.56s-53.46,52.8-13.84,71.62,63.47-44.45,63.47-44.45Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M950.33,1032.59s71.1-46.89,83.43,31.06L908,1235.1s-46.06-9.41-65.9-41.91C882.74,1129.8,950.33,1032.59,950.33,1032.59Z",
    transform: "translate(-517 -611)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M972.8,1003.55c8.6-3.4,19.44-5.55,33.11-5.55,66,0,68,40,68,40S1058.91,1013,972.8,1003.55Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 422.91,
    y: 632,
    width: 133,
    height: 8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M966.91,914l-10,77.13S799.91,964,822.91,787c13.94-107.25,110.8-146.53,194-140,26.27,2.06,70.79,18.2,101,41a196,196,0,0,1,49,55l-103,42-58,81s-27.67-26.15-54-14C925.91,864,931.91,918,966.91,914Z",
    transform: "translate(-517 -611)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cadre_invisible",
    "data-name": "cadre invisible"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 981,
    height: 981
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightFrame2);
export default __webpack_public_path__ + "static/media/right_frame_2.4079d5f22474103aaa5637d4b195ee7f.svg";
export { ForwardRef as ReactComponent };